var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevokeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 13C32.5 20.18 26.68 26 19.5 26H8.16L14.34 32.18L11.5 35L0.5 24L11.5 13L14.32 15.82L8.16 22H19.5C24.5 22 28.5 18 28.5 13C28.5 8 24.5 4 19.5 4H4.5V0H19.5C26.68 0 32.5 5.82 32.5 13Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevokeArrow);
export default __webpack_public_path__ + "static/media/RevokeArrow.f541292e3b54af3b5772d3625c7be04e.svg";
export { ForwardRef as ReactComponent };